'use strict';
import $ from 'jquery';
import { log } from './BpmnDebug';
import BpmnConfig from './BpmnConfig';
//import BpmnFormHelper from './BpmnFormHelper'

//import AutocompleteHelper from './AutocompleteHelper';
var BpmnApiHelper = {
    apiList: null,
    firstAttPrefix: "_first",
    additionalUrlParams: "additionalUrlParams"
};
export default BpmnApiHelper;

/**
 * Creates a new element and set the parent to it
 *
 * @method BpmnApiHelper#createElement
 *
 * @param {String} elementType of the new element
 * @param {Object} properties of the new element in key-value pairs
 * @param {moddle.object} parent of the new element
 * @param {BpmnFactory} factory which creates the new element
 *
 * @returns {djs.model.Base} element which is created
 */
BpmnApiHelper.createElement = function (elementType, properties, parent, factory) {
    var element = factory.create(elementType, properties);
    element.$parent = parent;

    return element;
};

/**
 * add params to the service task connector. Assumes this api name has changed.
 * if not changed we should not get into this call otherwise we may overwrite
 * some mappings
 * 1. find if connector is there or not. If not create
 * 2. find input/output params - clear them out
 * 3. for each of the api input params, need to create input params
 * - url, method, headers as well
 * 4. create output params
 * - response as the main object
 * - map of the output parameters, including response code(?)
 * - TBD what to do with a list - maybe full list, list of maps? need to test
 * list of maps.
 *
 * We should also store the params as extension types as well so that we can
 * access these later in the mappings
 * @param {type} extensionElements
 * @param {type} apiName
 * @param {type} apiDetails
 *
 *
 apiResult:
 account_id: "dev-itsmp"
 apiUrl: "https://dev-itsmp.gateway.apiplatform.io/v1/test1/:id"
 attributeMappings: Array(1)
 0: {value: "", key: ""}
 length: 1
 __proto__: Array(0)
 authModel: null
 block_attributes: null
 dataroot: null
 executor_category: "test1"
 executor_category_group: null
 executor_description: "PUT API for service: test1 with version: v1"
 executor_display_name: "puttest1"
 executor_method_type: "PUT"
 executor_name: "puttest1"
 executor_scope: "public"
 executor_type: "API"
 executor_version: "v1"
 executors: null
 headers: Array(3)
 0: {description: "", value: "3feb656f7628da883fefaed91f9501a2", key: "pkey"}
 1: {description: "", value: "dTcImCuGJIIcP8KRzn8vaV1csQH51mkc", key: "apikey"}
 2: {description: "", value: "application/json", key: "Content-Type"}
 length: 3
 __proto__: Array(0)
 id: 19237
 partner: "dev-itsmp"
 pathParams: Array(1)
 0: {annotation: "PathVariable", description: "ID or primary key value", value: "", key: "id"}
 length: 1
 __proto__: Array(0)
 prerequisites: null
 queryParams: null
 requestBody:
 annotation: "RequestBody"
 description: "Document in JSON format"
 key: "payload"
 value: ""
 __proto__: Object
 response: null
 responseAttributes: Array(2)
 0:
 apiAccessPolicy: "None"
 array: true
 attributeName: "firstname"
 attributeType: "None"
 autoIncrement: false
 customType: false
 dataStoragePolicy: "None"
 defaultValue: null
 description: null
 displayName: null
 displayPolicy: "None"
 precision: 0
 previousAttributeName: null
 required: false
 size: 255
 subType: []
 type: "mediumtext"
 updateOption: null
 __proto__: Object
 1: {attributeName: "lastname", displayName: null, description: null, type: "mediumtext", size: 255, �}
 length: 2
 __proto__: Array(0)
 service_provider: null
 workflow_credentials: null
 xml_blocks: null
 __proto__: Object
 name: "puttest1_v1"
 *
 *
 * @param {type} moddle
 * @returns {undefined}
 */
BpmnApiHelper.addApiParams = function (extensionElements, varName, apiDetails, moddle, existingMappingDestList) {
    log("extension elements", extensionElements.get('values'));
    log("moddle", moddle);
    let connector = BpmnApiHelper.getExtensionElement(extensionElements, 'camunda:Connector');
    if (!connector) {
        connector = moddle.create('camunda:Connector');
        extensionElements.get('values').push(connector);
    }
    let inputOutput = moddle.create('camunda:InputOutput');


    connector.connectorId = "http-connector";
    let inputParams = [];


    var variableName = varName;//BpmnApiHelper.getVariableName(apiDetails, 'element');
    var headers = BpmnApiHelper.addHeaders(moddle, apiDetails, inputParams);
    var method = BpmnApiHelper.addMethod(moddle, apiDetails, inputParams);
    var payload = BpmnApiHelper.addPayload(moddle, apiDetails, inputParams);
    var queryParams = BpmnApiHelper.addQueryParameters(moddle, apiDetails, inputParams);
    //    var responseCode = BpmnApiHelper.addResponseCode(moddle, apiDetails, variableName, inputParams);
    //    var responseCodeFailed = BpmnApiHelper.addResponseCodeFailed(moddle, apiDetails, variableName, inputParams);
    //    var responseParams = BpmnApiHelper.addResponseParameters(moddle, apiDetails, variableName, inputParams);
    //    var responseVariable = BpmnApiHelper.addResponseVariable(moddle, apiDetails, variableName, inputParams);
    //    var responseIsList = BpmnApiHelper.addResponseIsList(moddle, apiDetails, variableName, inputParams);
    var responseCodeFailed = BpmnApiHelper.addResponseCodeFailed(moddle, apiDetails, variableName, inputParams);
    var responseVariableMap = BpmnApiHelper.addResponseVariableMap(moddle, apiDetails, variableName, inputParams);


    var url = BpmnApiHelper.addUrl(moddle, apiDetails, inputParams);


    inputOutput.get('inputParameters').push(headers);


    inputOutput.get('inputParameters').push(method);
    if (payload) {
        inputOutput.get('inputParameters').push(payload);
    }
    inputOutput.get('inputParameters').push(url);


    //inputOutput.get('outputParameters').push(responseCode);
    inputOutput.get('outputParameters').push(responseVariableMap);
    inputOutput.get('outputParameters').push(responseCodeFailed);

    //inputOutput.get('outputParameters').push(responseVariable);
    //inputOutput.get('outputParameters').push(responseIsList);
    //if (responseParams) {
    //    inputOutput.get('outputParameters').push(responseParams);
    //}







    connector.inputOutput = inputOutput;
    // done at start extensionElements.get('values').push(connector);
    // with json mapping we don't want input mapping variables
    if (false) {

        let inputOutputForMapping = BpmnApiHelper.getExtensionElement(extensionElements, 'camunda:InputOutput');
        if (!inputOutputForMapping) {
            inputOutputForMapping = moddle.create('camunda:InputOutput');
            extensionElements.get('values').push(inputOutputForMapping);
        }
        /*
         *
         * need to store the existing input params in case we have made a mapping
         * if so we will reuse the mapping
         */
        //let existingInputMappingList = [];
        //    for (let i = 0; i < inputOutputForMapping.get('inputParameters').length; i++) {
        //        existingInputMappingList.push(inputOutputForMapping.get('inputParameters')[i]);
        //    }
        inputOutputForMapping.get('inputParameters').length = 0;


        for (let i = 0; i < inputParams.length; i++) {
            let name = inputParams[i];
            let mappingValue = ''

            for (let j = 0; j < existingMappingDestList.length; j++) {
                let existingMappingDest = existingMappingDestList[j];
                if (name === existingMappingDest.label) {
                    mappingValue = existingMappingDest.value;
                    continue;
                }
            }

            let inParam = moddle.create('camunda:InputParameter');
            inParam.name = name;
            inParam.value = mappingValue ? mappingValue : '';
            inputOutputForMapping.get('inputParameters').push(inParam);

        }
    }
    // done above extensionElements.get('values').push(inputOutputForMapping);
    log("extension elements", extensionElements);

};
BpmnApiHelper.getJsonForApiParams = function (varName, apiDetails_apiResult) {
    let result = {};
    var headers = BpmnApiHelper.addHeadersJson(apiDetails_apiResult, result);
    var method = BpmnApiHelper.addMethodJson(apiDetails_apiResult, result);
    var payload = BpmnApiHelper.addPayloadJson(apiDetails_apiResult, result);
    var queryParams = BpmnApiHelper.addQueryParametersJson(apiDetails_apiResult, result);
    BpmnApiHelper.addUrlJson(apiDetails_apiResult, result);
    return result;
}

BpmnApiHelper.getAuthModel = function (apiDetails) {
    let result = null;
    if (!apiDetails.authModel) {
        return result;
    }
    let {authAttributes, authType} = apiDetails.authModel;
    if (!authType) {
        return result;
    }
    switch (authType) {
        case 'bearer_token':
            result = {
                type: "Bearer",
                attributes: authAttributes,
                value: "Bearer ${empty Authorization ?'':Authorization}"

            };
            break;
        default:
            log("BpmnApiHelper.getAuthModel could not match auth model", authType);
    }
    return result;
}

/**
 * removes any special chars from the var name - looking at you Content-Type in header
 * @param {type} varName
 * @returns {String}
 */
BpmnApiHelper.convertToJSVarName = function (varName) {
    if (!varName) {
        return "";
    }
    var newVarName = varName.replace(/[^a-zA-Z0-9_]+/g, "_");
    log("BpmnApiHelper.convertToJSVarName ", varName, "->", newVarName);
    return newVarName;
}
/**
 * create the header map to add to the input parameters
 * @param {type} moddle
 * @param {type} apiDetails
 * @returns {BpmnApiHelper.addHeaders.headerMap|nm$_BpmnApiHelper.BpmnApiHelper.addHeaders.headerMap}
 */
BpmnApiHelper.addHeaders = function (moddle, apiDetails, inputParams) {
    log("BpmnApiHelper.addHeaders", apiDetails);
    let headerDetails = apiDetails.headers;
    if (!headerDetails) {
        return null;
    }
    let headerMap = moddle.create('camunda:Map');
    let foundApiKey = false;
    for (let i = 0; i < headerDetails.length; i++) {
        let headerDetail = headerDetails[i];
        let key = headerDetail.key;
        let safeKey = BpmnApiHelper.convertToJSVarName(key);
        let value = headerDetail.value;
        switch (key) {
            case 'pkey':
                value = "${empty pkey?'" + headerDetail.value + "':pkey}";
                break;
            case 'apikey':
                value = "${empty apikey?'" + headerDetail.value + "':apikey}";
                foundApiKey = true;
                break;
            default:
                value = "${empty " + safeKey + "?'" + headerDetail.value + "':" + safeKey + "}";
                break;

        }
        let headerEntry = moddle.create('camunda:Entry', {key: key, value: value});
        inputParams.push(key);
        headerMap.get('entries').push(headerEntry);
    }
    if (!foundApiKey) {
        let headerEntry = moddle.create('camunda:Entry', {key: 'apikey', value: '${apikey}'/*'JaG2SHtlxSHJp9j2tERr5R87L230o80U'*/});
        inputParams.push('apikey');
        headerMap.get('entries').push(headerEntry);

    }
    var authModel = BpmnApiHelper.getAuthModel(apiDetails);
    if (authModel) {
        let key = "Authorization";
        let value = authModel.value;
        let headerEntry = moddle.create('camunda:Entry', {key: key, value: value});
        inputParams.push(key);
        headerMap.get('entries').push(headerEntry);
    }

    let headerInputParam = moddle.create('camunda:InputParameter');
    headerInputParam.name = "headers";
    headerInputParam.definition = headerMap;
    return headerInputParam;
};

BpmnApiHelper.addHeadersJson = function (apiDetails, result) {
    log("BpmnApiHelper.addHeadersJson", apiDetails);
    let headerDetails = apiDetails.headers;
    if (!headerDetails) {
        return null;
    }
    let foundApiKey = false;
    for (let i = 0; i < headerDetails.length; i++) {
        let headerDetail = headerDetails[i];
        let key = headerDetail.key;
        let value = headerDetail.value;
        let safeKey = BpmnApiHelper.convertToJSVarName(key);

        result[safeKey] = value;
        if (key === 'apikey') {
            foundApiKey = true;
        }


    }
    if (!foundApiKey) {
        result['apikey'] = '';//JaG2SHtlxSHJp9j2tERr5R87L230o80U';
    }
    var authModel = BpmnApiHelper.getAuthModel(apiDetails);
    if (authModel) {
        let key = "Authorization";
        let value = authModel.value;
        result[key] = value;
    }
    return result;
};
BpmnApiHelper.addUrl = function (moddle, apiDetails, inputParams) {
    log("in add url", apiDetails);
    let name = apiDetails.executor;
    let version = apiDetails.executor_version;
    let url = apiDetails.apiUrl;
    /*
     *
     * url is of the format
     * apiUrl:�"https://dev-itsmp.gateway.apiplatform.io/v1/test1/:id"
     * so we should really be making the first part independent of environment
     *
     * also end part is a path param - so should have that
     *
     */
    let accountId = apiDetails.account_id;
    let environmentPart = "https://" + accountId + ".";
    if (url.startsWith(environmentPart)) {
        let newUrl = "https://${empty apiEnv?'" + accountId + "':apiEnv}." + url.substring(environmentPart.length);
        url = newUrl;
        inputParams.push('apiEnv');
    }
    // are there any path params?
    let pathParams = apiDetails.pathParams;
    if (pathParams) {
        for (let i = 0; i < pathParams.length; i++) {
            let pathParam = pathParams[i];
            let key = pathParam.key;
            let value = pathParam.value;
            let searchKey = ":" + key;// TODO word separator regex search
            let startPos = url.indexOf(searchKey);
            if (startPos > -1) {
                // found path param
                let startUrl = url.substring(0, startPos);
                let midUrl = "${empty " + key + "?'" + value + "':" + key + "}";
                let endUrl = url.substring(startPos + searchKey.length);
                url = startUrl + midUrl + endUrl;
                inputParams.push(key);
            } else {
                log("add url did not find key in url trying brace", key, pathParam);
                searchKey = "{" + key + '}';// TODO word separator regex search
                let startPos = url.indexOf(searchKey);
                if (startPos > -1) {
                    // found path param
                    let startUrl = url.substring(0, startPos);
                    let midUrl = "${empty " + key + "?'" + value + "':" + key + "}";
                    let endUrl = url.substring(startPos + searchKey.length);
                    url = startUrl + midUrl + endUrl;
                    inputParams.push(key);

                }
            }
        }
    }
    let queryParams = BpmnApiHelper.addQueryParameters(moddle, apiDetails, inputParams);
    let inputParam = moddle.create('camunda:InputParameter');
    inputParam.name = "url";
    inputParam.value = url + queryParams + "${empty " + BpmnApiHelper.additionalUrlParams + " ?'':" + BpmnApiHelper.additionalUrlParams + "}";
    return inputParam;
};

BpmnApiHelper.addUrlJson = function (apiDetails, result) {
    log("in add addUrlJson", apiDetails);


    let url = apiDetails.apiUrl;
    /*
     *
     * url is of the format
     * apiUrl:�"https://dev-itsmp.gateway.apiplatform.io/v1/test1/:id"
     * so we should really be making the first part independent of environment
     *
     * also end part is a path param - so should have that
     *
     */
    let accountId = apiDetails.account_id;
    let environmentPart = "https://" + accountId + ".";
    if (url.startsWith(environmentPart)) {
        let newUrl = "https://${empty apiEnv?'" + accountId + "':apiEnv}." + url.substring(environmentPart.length);
        url = newUrl;
        result.apiEnv = accountId;

    }
    // are there any path params?
    let pathParams = apiDetails.pathParams;
    if (pathParams) {
        for (let i = 0; i < pathParams.length; i++) {
            let pathParam = pathParams[i];
            let key = pathParam.key;
            let value = pathParam.value;
            let searchKey = ":" + key;// TODO word separator regex search
            let startPos = url.indexOf(searchKey);
            if (startPos > -1) {
                // found path param
                let startUrl = url.substring(0, startPos);
                let midUrl = "${empty " + key + "?'" + value + "':" + key + "}";
                let endUrl = url.substring(startPos + searchKey.length);
                url = startUrl + midUrl + endUrl;
                result[key] = value;

            } else {
                log("add url did not find key in url trying brace", key, pathParam);
                searchKey = "{" + key + '}';// TODO word separator regex search
                let startPos = url.indexOf(searchKey);
                if (startPos > -1) {
                    // found path param
                    let startUrl = url.substring(0, startPos);
                    let midUrl = "${empty " + key + "?'" + value + "':" + key + "}";
                    let endUrl = url.substring(startPos + searchKey.length);
                    url = startUrl + midUrl + endUrl;
                    result[key] = value;

                }
            }
        }
    }
    result[BpmnApiHelper.additionalUrlParams] = "";

    return result;
};

BpmnApiHelper.addMethod = function (moddle, apiDetails, inputParams) {

    let method = apiDetails.executor_method_type;
    let inputParam = moddle.create('camunda:InputParameter');
    inputParam.name = "method";
    inputParam.value = method;
    return inputParam;
};

BpmnApiHelper.addMethodJson = function (apiDetails, result) {

    let method = apiDetails.executor_method_type;
    result.method = method;

    return result;
};
BpmnApiHelper.getJSCommonDebugPart = function () {
    return    "load('classpath:linx_bpmn_helper.js');\n";
};

BpmnApiHelper.addPayload = function (moddle, apiDetails, inputParams) {
    if (BpmnApiHelper.isGetApi(apiDetails)) {
        log("get API so no payload");
        return null;
    }
    let requestBody = apiDetails.requestBody;
    if (!requestBody) {
        return null;
    }
    let payload = requestBody.key;

    if (!payload) {
        return null;
    }
    let value = requestBody.value;

    let valueScript = moddle.create('camunda:Script', {
        'scriptFormat': 'JavaScript',
        'value': BpmnApiHelper.getJSCommonDebugPart() +
                "\n\n" +
                "var payloadString = getPayloadString();\n" +
                "payloadString;\n"

    });

    let inputParam = moddle.create('camunda:InputParameter');
    inputParam.name = "payload";
    inputParam.definition = valueScript;

    inputParams.push('payload');
    return inputParam;
};
BpmnApiHelper.isGetApi = function (apiDetails) {
    let executor_method_type = apiDetails.executor_method_type;
    return executor_method_type === "GET";
}
BpmnApiHelper.addPayloadJson = function (apiDetails, result) {
    log("BpmnApiHelper.addPayloadJson", apiDetails, result);
    if (BpmnApiHelper.isGetApi(apiDetails)) {
        log("get API so no payload");
        return null;
    }
    let requestBody = apiDetails.requestBody;
    if (!requestBody) {
        return null;
    }
    let payload = requestBody.key;

    if (!payload) {
        return null;
    }

    let value = requestBody.value;
    if (value) {
        result.payload = {};
        //result.payload = value;
        if (Array.isArray(value)) {
            for (var i = 0; i < value.length; i++) {
                var v = value[i];
                var att = {
                    array: v.array,
                    type: v.type,
                    attributeName: v.key,
                    defaultValue: v.value,
                    subType: v.subType

                };

                BpmnApiHelper.mapResponseAttToPayloadJson(att, result.payload)
            }
        } else {
            result.payload = value;
        }
    } else {
        // guess the payload based on the response attributes
        let responseAttributes = apiDetails.responseAttributes;
        if (!responseAttributes) {
            return null;
        }
        result.payload = {};
        for (var i = 0; i < responseAttributes.length; i++) {
            let att = responseAttributes[i];
            let attName = att.attributeName;
            if (attName) {
                BpmnApiHelper.mapResponseAttToPayloadJson(att, result.payload)

            }
        }
    }



    return result;
};

BpmnApiHelper.mapResponseAttToPayloadJson = function (att, payload) {
    log("BpmnApiHelper.mapResponseAttToPayloadJson", att, payload);
    let {array, type, attributeName, defaultValue, subType} = att;
    log("BpmnApiHelper.mapResponseAttToPayloadJson", array, type, attributeName, defaultValue, subType);
    if (!attributeName) {
        return;
    }
    if (!defaultValue) {
        defaultValue = attributeName;
    }
    switch (type) {
        case "Object":
            let subPayload = {};
            for (let i = 0; i < subType.length; i++) {
                let subAtt = subType[i];
                BpmnApiHelper.mapResponseAttToPayloadJson(subAtt, subPayload);
            }
            if (array) {
                payload[attributeName] = [subPayload];
            } else {
                payload[attributeName] = subPayload;
            }
            break;

        default:
            if (array) {
                payload[attributeName] = [defaultValue];
            } else {
                payload[attributeName] = defaultValue;
            }
    }

}
BpmnApiHelper.addQueryParameters = function (moddle, apiDetails, inputParams) {
    let queryParams = apiDetails.queryParams;
    if (!queryParams) {
        return "";
    }
    let queryParamString = "";
    let sep = "?";
    for (let i = 0; i < queryParams.length; i++) {
        let queryParam = queryParams[i];
        let key = queryParam.key;
        let value = "";//queryParam.value; may not want to have query params if empty
        if (key) {
            queryParamString = queryParamString + sep + key + "=${empty " + key + "?'" + value + "':" + key + "}";
            sep = "&";
            inputParams.push(key);
        }
    }

    return queryParamString;
};
BpmnApiHelper.addQueryParametersJson = function (apiDetails, result) {
    let queryParams = apiDetails.queryParams;
    if (!queryParams) {
        return "";
    }


    for (let i = 0; i < queryParams.length; i++) {
        let queryParam = queryParams[i];
        let key = queryParam.key;
        let value = queryParam.value;
        if (key) {

            result[key] = value;

        }
    }

    return result;
};
BpmnApiHelper.getVariableName = function (apiDetails, element, inputParams) {
    return apiDetails.executor_name;
}

BpmnApiHelper.addResponseCodeFailed = function (moddle, apiDetails, variableName, inputParams) {

    let valueScript = moddle.create('camunda:Script', {
        'scriptFormat': 'JavaScript',
        'value': BpmnApiHelper.getJSCommonDebugPart() +
                " var isFailed = createVariables('" + variableName + "');\n" +
                " isFailed;"
    });


    let attrOutputParam = moddle.create('camunda:OutputParameter');
    attrOutputParam.name = "_errorCode";
    attrOutputParam.definition = valueScript;
    return attrOutputParam;
};
BpmnApiHelper.addResponseVariableMap = function (moddle, apiDetails, variableName, inputParams) {


    //let variableName = BpmnApiHelper.getVariableName(apiDetails, element);
    let paramsToAdd = [
        'responseCode',
        'isFailed',
        //'data',
        'isList',
        'hasContents'
    ];
    let paramsMap = moddle.create('camunda:Map');
    for (let i = 0; i < paramsToAdd.length; i++) {
        let paramEntry = moddle.create('camunda:Entry', {key: paramsToAdd[i], value: ''});
        paramsMap.get('entries').push(paramEntry);
    }

    let responseAttributes = apiDetails.responseAttributes;
    if (responseAttributes && responseAttributes.length) {
        let attrMap = moddle.create('camunda:Map');
        let haveAttributes = false;
        for (let i = 0; i < responseAttributes.length; i++) {
            let attribute = responseAttributes[i];
            let key = attribute.attributeName;
            if (!key) {
                continue;
            }
            let attributeType = attribute.type;
            //${not puttest1.hasProp('firstname')?'':puttest1.prop('firstname')}
            //${test1?lastname.elements().get(0).hasProp('firstname')?lastname.elements().get(0).prop('firstname'):'':''}

            let value = '';

            let attrEntry = moddle.create('camunda:Entry', {key: key, value: value});
            attrMap.get('entries').push(attrEntry);
            haveAttributes = true;
        }
        if (haveAttributes) {
            paramsMap.get('entries').push(moddle.create('camunda:Entry', {key: BpmnApiHelper.firstAttPrefix, definition: attrMap}));
            paramsMap.get('entries').push(moddle.create('camunda:Entry', {key: 'data', definition: attrMap}));
        } else {
            paramsMap.get('entries').push(moddle.create('camunda:Entry', {key: 'data', value: ''}));
        }
    }



    let attrOutputParam = moddle.create('camunda:OutputParameter');
    attrOutputParam.name = variableName;
    attrOutputParam.definition = paramsMap;
    return attrOutputParam;



};

BpmnApiHelper.addResponseVariable = function (moddle, apiDetails, variableName, inputParams) {

    let valueScript = moddle.create('camunda:Script', {
        'scriptFormat': 'JavaScript',
        'value': " \n" +
                "var response = connector.getVariable('response');\n" +
                "var responseCode = connector.getVariable('statusCode');\n" +
                "//create a default response empty body\n" +
                "var res = S('[]');\n" +
                "// check response code is ok\n" +
                "if (responseCode > 199 && responseCode < 300) {\n" +
                "    res = S(response);\n" +
                "}\n" +
                "res;"
    });


    let attrOutputParam = moddle.create('camunda:OutputParameter');
    attrOutputParam.name = variableName;
    attrOutputParam.definition = valueScript;
    return attrOutputParam;
};

BpmnApiHelper.addResponseIsList = function (moddle, apiDetails, variableName, inputParams) {

    let valueScript = moddle.create('camunda:Script', {
        'scriptFormat': 'JavaScript',
        'value': " var response = connector.getVariable('response');\n" +
                "var responseCode = connector.getVariable('statusCode');\n" +
                "//create a default response empty body\n" +
                "var isarray = false;\n" +
                "// check response code is ok\n" +
                "if (responseCode > 199 && responseCode < 300) {\n" +
                "    res = JSON.parse(response);\n" +
                "    isarray = Array.isArray(res) && res.length;\n" + // make sure it has elements
                "}\n" +
                "!!isarray;\n"// so it is a boolean
    });


    let attrOutputParam = moddle.create('camunda:OutputParameter');
    attrOutputParam.name = variableName + "_IsList";
    attrOutputParam.definition = valueScript;
    return attrOutputParam;
};

BpmnApiHelper.addResponseParameters = function (moddle, apiDetails, variableName, inputParams) {
    let responseAttributes = apiDetails.responseAttributes;
    if (!responseAttributes) {
        return null;
    }
    //let variableName = BpmnApiHelper.getVariableName(apiDetails, element);
    let attrMap = moddle.create('camunda:Map');
    for (let i = 0; i < responseAttributes.length; i++) {
        let attribute = responseAttributes[i];
        let key = attribute.attributeName;
        let attributeType = attribute.type;
        //${not puttest1.hasProp('firstname')?'':puttest1.prop('firstname')}
        //${test1?lastname.elements().get(0).hasProp('firstname')?lastname.elements().get(0).prop('firstname'):'':''}
        let isList = variableName + "_IsList";
        let hasPropPart = ".hasProp('" + key + "')";
        let propPart = ".prop('" + key + "').toString()";
        let firstArrayPart = ".elements().get(0)";

        let value = "${" + isList // is it a list
                + "?" + variableName + firstArrayPart + hasPropPart // does it have the prop
                + "?" + variableName + firstArrayPart + propPart // return the element 0 prop
                + ":''" //end array has prop // empty
                + ":" + variableName + hasPropPart // start not is list - do we have  a prop
                + "?" + variableName + propPart // return prop
                + ":''" // return empty
                + "}";

        let attrEntry = moddle.create('camunda:Entry', {key: key, value: value});
        attrMap.get('entries').push(attrEntry);
    }

    let attrOutputParam = moddle.create('camunda:OutputParameter');
    attrOutputParam.name = variableName + "_Params";
    attrOutputParam.definition = attrMap;
    return attrOutputParam;
};


BpmnApiHelper.addResponseCode = function (moddle, apiDetails, variableName, inputParams) {

    let value = "${statusCode}";// can get status code directly


    let attrOutputParam = moddle.create('camunda:OutputParameter');
    attrOutputParam.name = variableName + "_RC";
    attrOutputParam.value = value;
    return attrOutputParam;
};


BpmnApiHelper.getExtensionElement = function (extensionElements, type) {
    if (!extensionElements || !extensionElements.values) {
        return;
    }

    return extensionElements.values.filter((extensionElement) => {
        return extensionElement.$instanceOf(type);
    })[0];
}

/**
 * adds the script to the extension elements as a listener event.
 * replaces the event if it is already there
 * @param {type} extensionElements
 * @param {type} event
 * @param {type} script
 * @param {type} moddle
 * @returns {extensionElements}
 */
BpmnApiHelper.addEventListenerScript = function (extensionElements, event, script, moddle) {
    if (!extensionElements || !extensionElements.values) {
        return extensionElements;
    }
    let type = 'camunda:ExecutionListener';
    let values = extensionElements.values;
    for (let i = 0; i < values.length; i++) {
        let extensionElement = values[i];
        if (!extensionElement.$instanceOf(type)) {
            continue;
        }
        if (extensionElement.event === event) {
            log("addStartListenerScript found  event", event, i, extensionElement);
            extensionElement.script = script;
            return extensionElements;
        }

    }
    log("addStartListenerScript did not find event", event, "so adding");
    let listener = moddle.create(type);
    listener.event = event;
    listener.script = script;
    extensionElements.get('values').push(listener);
    return extensionElements;

}

BpmnApiHelper.addJsonMapping = function (jsonScript, varName, moddle) {
    /*
     *
     *  <bpmn2:userTask id="Activity_04jm51d">
     <bpmn2:extensionElements>
     <camunda:executionListener event="start">
     <camunda:script scriptFormat="JavaScript">	function debugInfo(str...) {

     var str = "";
     for (var i = 0; i &lt; arguments.length; i++) {
     str = str + " " + arguments[i];
     }

     print( str);
     }
     function printAll(obj){
     debugInfo("In print all");
     for(var propName in obj) {
     propValue = obj[propName];

     debugInfo(propName,propValue);
     }

     }


     var variables = execution.getVariables();
     debugInfo("Start execution variables",variables);
     printAll(variables);
     */

    let value =
            BpmnApiHelper.getJSCommonDebugPart() +
            "\n" +
            "\n" +
            "var variables = execution.getVariables();\n" +
            "debugInfo('Start execution" + varName + " ');\n" +
            "debugTrace('Start execution variables', variables);\n" +
            "printAll(variables);\n" +
            "\n" +
            jsonScript +
            "\n" +
            "if(!var0['" + BpmnApiHelper.additionalUrlParams + "']){\n" +
            " var0['" + BpmnApiHelper.additionalUrlParams + "']='';\n" +
            "}\n" +
            "printAll(var0);\n" +
            "createWFVariables(var0);\n" +
            " var map = new java.util.TreeMap();\n" +
            " map.put('isFailed', false);\n" +
            " //execution.setVariableLocal('" + varName + "',map);\n" +
            "variables = execution.getVariables();\n" +
            "debugTrace('Start execution " + varName + " after variables', variables);\n" +
            "printAll(variables);\n" +
            "\n"
            ;




    let valueScript = moddle.create('camunda:Script', {
        'scriptFormat': 'JavaScript',
        'value': value
    });

    return valueScript;
};

BpmnApiHelper.localCreds = {
    environment: "xx",
    xx: {
        partner: "xx",
        accountId: "xx",
        partnerKey: "xx"
    }
};



BpmnApiHelper.getPartner = function () {
    let partner = localStorage.getItem('partner');
    if (partner) {
        log("Using local storage partner");
        return partner;
    }
    return BpmnApiHelper.localCreds[BpmnApiHelper.localCreds.environment].partner;
}

BpmnApiHelper.getAccountId = function () {
    let account = localStorage.getItem('account');
    if (account) {
        return account;
    }
    return BpmnApiHelper.localCreds[BpmnApiHelper.localCreds.environment].accountId;
}
BpmnApiHelper.getPartnerKey = function () {
    return BpmnApiHelper.localCreds[BpmnApiHelper.localCreds.environment].partnerKey;
}
BpmnApiHelper.getAPIs = function (element, bpmnFactory, options, translate) {
    let storageType = sessionStorage;
    if (true) {
        storageType.removeItem('dataAccessAPI');
        storageType.removeItem('sqlQueryAPI');
        storageType.removeItem('businessLogicAPI');
        storageType.removeItem('thirdPartyAPI');
        //storageType.removeItem('b2bAPI');
    }

    BpmnApiHelper.apiList = [];
    BpmnApiHelper.apiList.push({value: "Select", name: "Select Registered API"});

    try {


        let confService = BpmnConfig.confService;

        BpmnApiHelper.doConfServiceGetApi('API', 'dataAccessAPI', confService, storageType);
        BpmnApiHelper.doConfServiceGetApi('BUSINESSLOGIC', 'businessLogicAPI', confService, storageType);
        BpmnApiHelper.doConfServiceGetApi('THIRDPARTY', 'thirdPartyAPI', confService, storageType);
        BpmnApiHelper.doConfServiceGetApi('SQLQUERY', 'sqlQueryAPI', confService, storageType);
        BpmnApiHelper.doConfServiceGetApi('WORKFLOW', 'workFlowAPI', confService, storageType);
        BpmnApiHelper.doConfServiceGetApi('DECISION', 'dmnAPI', confService, storageType);
        log("checking if conf service");
        if (confService) {
            log("getting b2b apis");
            BpmnApiHelper.getB2BApis(confService, storageType);
        } else {

            BpmnApiHelper.local_getB2BApi(storageType, 'b2bAPI')
        }
        var b2bAPI = storageType.getItem('b2bAPI');


    } catch (err) {
        log("got error ", err);
        BpmnApiHelper.apiList = [{value: "Select", name: "Select Registered API"}];
    }

    return BpmnApiHelper.apiList;
}
BpmnApiHelper.getB2BApis = function (confService, storageType) {
    let partner = BpmnApiHelper.getPartner();
    let account = BpmnApiHelper.getAccountId();

    confService.getSettingsV2CRUD(partner, account, 'x')
            .subscribe(data => {
                let subscriptions = data.body[0].subscriptions;
                if (!subscriptions) {
                    log("getSettingsCRUD no subscriptions");
                    return;
                }
                let providers = subscriptions.providers;
                if (!providers || !providers.length) {
                    log("getSettingsCRUD no providers");
                    return;
                }
                let providerFilter = "";
                let sep = "";
                for (let i = 0; i < providers.length; i++) {
                    providerFilter = providerFilter + sep + providers[i].producer;
                    sep = ",";
                }
                confService.getSubscribedExecutors('b2b', 'b2b', providerFilter).subscribe(b2bData => {
                    if (!b2bData) {
                        log("no subscriptions");
                        return;
                    }
                    for (let j = 0; j < b2bData.length; j++) {
                        let subscr = b2bData[j];
                        let categories = subscr.categories;
                        for (let k = 0; k < categories.length; k++) {
                            let apiResultList = categories[k].executors;
                            BpmnApiHelper.populateAutocompleteArray(apiResultList, BpmnApiHelper.apiList);
                        }
                    }

                }, error => {
                    log("could not get b2b apis", error);
                }
                );
                    confService.getMyProviderExecutors(localStorage.getItem('partner'), localStorage.getItem('account'), providerFilter).subscribe(b2bData => {
                            if (!b2bData) {
                                log("no subscriptions");
                                return;
                            }
                            for (let j = 0; j < b2bData.length; j++) {
                                let subscr = b2bData[j];
                                let categories = subscr.categories;
                                for (let k = 0; k < categories.length; k++) {
                                    let apiResultList = categories[k].executors;
                                    BpmnApiHelper.populateAutocompleteArray(apiResultList, BpmnApiHelper.apiList);
                                }
                            }

                        }, error => {
                            log("could not get b2b apis", error);
                        }
                    );
            }
            , error => {
                log("could not get crud settings", error);
            });
}
BpmnApiHelper.doConfServiceGetApi = function (apiType, dataStorageName, confService, storageType) {
    var data = storageType.getItem(dataStorageName);
    if (data) {
        BpmnApiHelper.populateAutocompleteArray(JSON.parse(data), BpmnApiHelper.apiList);
    } else {
        let partner = BpmnApiHelper.getPartner();
        let account = BpmnApiHelper.getAccountId();
        if (!BpmnConfig.confService) {
            BpmnApiHelper.local_getApiExecutorsByPartnerAccountType(partner, account, apiType, storageType, dataStorageName);
        } else {
            confService.getApiExecutorsByPartnerAccountType(partner, account, apiType).subscribe(data => {
                storageType.setItem(dataStorageName, JSON.stringify(data));
                BpmnApiHelper.populateAutocompleteArray(data, BpmnApiHelper.apiList);
                return data;

            }, error => {
                log("error retrieving api", apiType, dataStorageName, error);
                // this.platform.handleErrorGracefully(error, 'Error while retreiving API executor by type. Please try after sometime.');
            });
        }
    }
}

BpmnApiHelper.local_getApiExecutorsByPartnerAccountType = function (partner, account, apiType, storageType, dataStorageName) {
    var
            urlValue = 'https://services.apiplatform.io/v1/api/' + partner + '/' + account + '/executors/type/',
            pkey = BpmnApiHelper.getPartnerKey(),
            data = null;
    log("local_getApiExecutorsByPartnerAccountType", partner, account, apiType, storageType, dataStorageName, pkey);

    $.ajax({
        url: urlValue + apiType,
        method: "GET",
        headers: {'pkey': pkey},
        success: function (result) {
            data = result;
            log("data access api rest api", result);
            storageType.setItem(dataStorageName, JSON.stringify(data));
            BpmnApiHelper.populateAutocompleteArray(data, BpmnApiHelper.apiList);

        },
        async: false
    });
    return data;


}


BpmnApiHelper.local_getB2BApi = function (storageType, dataStorageName) {
    let partner = BpmnApiHelper.getPartner();
    let account = BpmnApiHelper.getAccountId();
    var
            urlValue = 'https://services.apiplatform.io/v1/api/b2b/b2b/producer/executors?producer=ecwid,slack,atlassian,servicenow,shopify,endlessmedical,gold,currencyandexchange,weather,aws,microfocus,AWS%20API%20Gateway,outlook',
            pkey = '3fd7244d02a830763fcddf5c572a5b54', //BpmnApiHelper.getPartnerKey(),
            data = null;
    log("local_getApiExecutorsByPartnerAccountType", partner, account, storageType, dataStorageName, pkey);

    $.ajax({
        url: urlValue,
        method: "GET",
        headers: {'pkey': pkey},
        success: function (result) {
            var b2bData = result;
            log("!!!!!!!!b2b api data access api rest api", result);
            for (let j = 0; j < b2bData.length; j++) {
                let subscr = b2bData[j];
                let categories = subscr.categories;
                for (let k = 0; k < categories.length; k++) {
                    let apiResultList = categories[k].executors;
                    BpmnApiHelper.populateAutocompleteArray(apiResultList, BpmnApiHelper.apiList);
                }
            }
            // storageType.setItem(dataStorageName, JSON.stringify(data));


        },
        async: false
    });
    return data;


}

BpmnApiHelper.populateAutocompleteArray = function (apiResultList, apiListOut) {
    if (!apiResultList) {
        return;
    }
    for (let i = 0; i < apiResultList.length; i++) {
        let apiResult = apiResultList[i];
        let prefix = '';
        if (apiResult.service_provider) {
            prefix = apiResult.service_provider + ':';
        }
        let name = prefix + apiResult.executor_name + '_' + apiResult.executor_version;
        apiListOut.push(
                {
                    name: name,
                    apiResult: apiResult
                });
    }
}
BpmnApiHelper.findApiFromName = function (apiName, apiList) {
    if (!apiName || !apiList) {
        return null;
    }
    for (let i = 0; i < apiList.length; i++) {
        let api = apiList[i];
        if (apiName === api.name) {
            log("matched api ", api, i);
            return api;
        }
    }
    log("did not match api ", apiName);
};

BpmnApiHelper.getJsonObjectToPathInitial = function (varName, obj) {
    var outputArr = [];
    if (Array.isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            BpmnApiHelper.getJsonObjectToPath(obj[i], varName, outputArr);
        }
    } else {
        BpmnApiHelper.getJsonObjectToPath(obj, varName, outputArr);
    }
    return outputArr;
};
BpmnApiHelper.getJsonObjectToPath = function (obj, curPath, outputArr) {
    for (var propName in obj) {
        var path = (curPath ? curPath + "." : '') + propName;
        outputArr.push(path);
        var propValue = obj[propName];
        //console.log("type", propName, typeof propValue, Array.isArray(propValue));
        if (Array.isArray(propValue)) {
            if (propValue.length) {
                outputArr.push(path + ".length");
                BpmnApiHelper.getJsonObjectToPath(propValue[0], path + "[0]", outputArr);

            }
        } else {

            if (typeof propValue === "object") {
                //console.log("Object", propName, propValue);
                BpmnApiHelper.getJsonObjectToPath(propValue, path, outputArr);
            }
        }

    }
};
BpmnApiHelper.getSrcVarsFromDocumentation = function (
        documentationArray,
        rootLabel,
        flowId,
        flowName,
        flowType,
        paramList
        )
{

    if (!documentationArray) {
        return;
    }
    for (var d = 0; d < documentationArray.length; d++) {
        var documentation = documentationArray[d].text;

        try {
            var searchString = "returns";
            var returnPos = documentation.indexOf(searchString);
            if (returnPos >= 0){
                documentation = documentation.substring(returnPos + searchString.length);
            }

            var obj = JSON.parse(documentation);
            var outputVars = BpmnApiHelper.getJsonObjectToPathInitial(rootLabel, obj);
            if (outputVars && outputVars.length) {
                for (var i = 0; i < outputVars.length; i++) {
                    var outputVar = outputVars[i];
                    let subEntry = {
                        defaultValue: '',
                        id: outputVar,
                        label: outputVar,
                        type: 'string',
                        flowId: flowId,
                        flowName: flowName,
                        flowType: flowType
                    };
                    paramList.push(subEntry);
                }
            }

        } catch (e) {
            log('could not parse', documentation, e);

        }
    }
};
BpmnApiHelper.getSrcVarsFromFlowElement = function (flowElement, paramList) {
    if (!flowElement) {
        return;
    }
    var documentation = flowElement.documentation;
    if (!documentation) {
        return;
    }
    var variableName = '';
    let loopCharacteristics = flowElement.loopCharacteristics;
    if (loopCharacteristics) {
        variableName = loopCharacteristics.elementVariable;
    }
    let {id,name,varName, resultVariable} = flowElement;
    if (varName) {
        variableName = varName;
    }
    if (resultVariable) {
        variableName = resultVariable;
    }
    let flowId = id;
    let flowName = name ? name : flowId;
    let flowType = flowElement.$type;


    BpmnApiHelper.getSrcVarsFromDocumentation(
            documentation,
            variableName,
            flowId,
            flowName,
            flowType,
            paramList
            );
};


BpmnApiHelper.getAllSrcParams = function (bpmnModeler) {
    log('getAllSrcParams bpmnModeler', bpmnModeler);
    let definitions = bpmnModeler._definitions;
    log('getAllSrcParams definitions', definitions);
    let rootElements = definitions.rootElements;
    let paramList = [];

    for (let i = 0; i < rootElements.length; i++) {
        let rootElement = rootElements[i];
        let flowElements = rootElement.flowElements;
        // TODO subprocess had flowElements - need to go down there as well
        BpmnApiHelper.getAllSrcParamsFlowElements(flowElements, paramList);
    }

    for (let i = 0; i < rootElements.length; i++) {
        let rootElement = rootElements[i];
        let flowElements = rootElement.flowElements;
        BpmnApiHelper.getAllSrcParamsSubFlowElements(flowElements, paramList);

    }

    log("getAllParams paramList", paramList);
    return paramList;
};

BpmnApiHelper.getAllSrcParamsFlowElements = function (flowElements, paramList) {
    if (!flowElements) {
        return;
    }
    for (let j = 0; j < flowElements.length; j++) {
        let flowElement = flowElements[j];
        let extensionElements = flowElement.extensionElements;
        if (extensionElements) {

            let connector = BpmnApiHelper.getExtensionElement(extensionElements, 'camunda:Connector');
            let inout = BpmnApiHelper.getExtensionElement(extensionElements, 'camunda:InputOutput');
            let formData = BpmnApiHelper.getExtensionElement(extensionElements, "camunda:FormData");
            let props = BpmnApiHelper.getExtensionElement(extensionElements, "camunda:Properties");
            BpmnApiHelper.getConnectorOutParams(connector, paramList, flowElement);
            BpmnApiHelper.getInOutOutParams(inout, paramList, flowElement);
            BpmnApiHelper.getFormDataOutParams(formData, paramList, flowElement);
            BpmnApiHelper.getPropsOutParams(props, paramList, flowElement);
        }
        BpmnApiHelper.getResultVariableParams(flowElement, paramList);
        BpmnApiHelper.getSrcVarsFromFlowElement(flowElement, paramList);
        if (flowElement.flowElements) {
            log("BpmnApiHelper.getAllSrcParamsFlowElements going down flowelements", flowElement, paramList);
            BpmnApiHelper.getAllSrcParamsFlowElements(flowElement.flowElements, paramList);
            log("after going down", paramList);
        }
    }
}
BpmnApiHelper.getAllSrcParamsSubFlowElements = function (flowElements, paramList) {
    if (!flowElements || !flowElements.length) {
        log("getAllSrcParamsSubFlowElements no elements");
        return;
    }
    for (let j = 0; j < flowElements.length; j++) {
        let flowElement = flowElements[j];
        BpmnApiHelper.getSrcVarsFromFlowElement(flowElement, paramList);
        BpmnApiHelper.getLoopConditionOutParams(flowElement, paramList, flowElement)
        if (flowElement.flowElements) {
            BpmnApiHelper.getAllSrcParamsSubFlowElements(flowElement.flowElements, paramList)
        }
    }
}

BpmnApiHelper.getAllDestParams = function (businessElement) {
    log("getAllDestParams businessElement ", businessElement);
    let paramList = [];
    let extensionElements = businessElement.extensionElements;
    if (!extensionElements) {
        return paramList;
    }

    let inout = BpmnApiHelper.getExtensionElement(extensionElements, 'camunda:InputOutput');


    BpmnApiHelper.getInOutInParams(inout, paramList, businessElement);
    return paramList;

}
BpmnApiHelper.getResultVariableParams = function (flowElement, paramList) {
    let resultVariable = flowElement.resultVariable;
    if (!resultVariable) {
        return;
    }
    let flowId = flowElement.id;
    let flowName = flowElement.name ? flowElement.name : flowId;
    let flowType = flowElement.$type;
    let result = {
        defaultValue: '',
        id: resultVariable,
        label: resultVariable,
        type: 'string',
        flowId: flowId,
        flowName: flowName,
        flowType: flowType
    };
    paramList.push(result);
}
BpmnApiHelper.getConnectorOutParams = function (element, paramList, flowElement) {
    if (!element) {
        return;
    }
    let inputOutput = element.inputOutput;
    if (!inputOutput) {
        return;
    }
    let outputParameters = inputOutput.outputParameters;
    if (!outputParameters) {
        return;
    }
    let flowId = flowElement.id;
    let flowName = flowElement.name ? flowElement.name : flowId;
    let flowType = flowElement.$type;
    for (let i = 0; i < outputParameters.length; i++) {
        let outputParameter = outputParameters[i];
        let varName = outputParameter.name;
        let definition = outputParameter.definition;
        if (definition) {
            let defType = definition.$type;
            switch (defType) {
                case "camunda:Map":
                    BpmnApiHelper.getMapParams(varName, definition, paramList, flowId, flowName, flowType);
                    break;

            }
        }

        let result = {
            defaultValue: '',
            id: outputParameter.name,
            label: outputParameter.name,
            type: outputParameter.definition ? outputParameter.definition.$type : 'string',
            flowId: flowId,
            flowName: flowName,
            flowType: flowType


        };
        paramList.push(result);
    }
    BpmnApiHelper.getConnectorOutParamsFromApi(element, paramList, flowElement, flowId, flowName, flowType);
}

/*
 * "customType": false,
 "apiAccessPolicy": "None",
 "attributeName": "totalHours",
 "type": "Object",
 "array": true,
 "size": null,
 "precision": null,
 "autoIncrement": false,
 "defaultValue": null,
 "attributeType": "None",
 "dataStoragePolicy": "None",
 "description": null,
 "displayName": null,
 "displayPolicy": null,
 "required": false,
 "subType": [{
 "customType": false,
 */


BpmnApiHelper.getConnectorOutParamsFromApi = function (element, paramList, flowElement, flowId, flowName, flowType) {
    log("getConnectorOutParamsFromApi enter", element, paramList, flowElement);
    let {api, varName} = flowElement;
    if (!api || !varName) {
        return;
    }
    let apiList = BpmnApiHelper.apiList;

    let apiDetails = BpmnApiHelper.findApiFromName(api, apiList);
    if (!apiDetails) {
        log("did not find apiName", api);
        return;
    }
    let apiResult = apiDetails.apiResult;
    let responseAttributes = apiResult.responseAttributes;
    if (responseAttributes) {
        BpmnApiHelper.getConnectorOutParamsFromApiInner(varName, paramList, responseAttributes, flowId, flowName, flowType);
        BpmnApiHelper.getConnectorOutParamsFromApiInner(varName + "." + BpmnApiHelper.firstAttPrefix, paramList, responseAttributes, flowId, flowName, flowType);

    }

}
BpmnApiHelper.getConnectorOutParamsFromApiInner = function (varName, paramList, responseAttributes, flowId, flowName, flowType) {
    if (responseAttributes) {

        for (let i = 0; i < responseAttributes.length; i++) {
            let attribute = responseAttributes[i];
            let {array, attributeName, defaultValue, type, subType} = attribute;
            let key = attributeName;
            let entryName = varName + "." + key;
            let subEntry = {
                defaultValue: defaultValue,
                id: entryName,
                label: entryName,
                type: 'string',
                flowId: flowId,
                flowName: flowName,
                flowType: flowType
            }
            if (type === 'Object') {
                BpmnApiHelper.getConnectorOutParamsFromApiInner(entryName, paramList, subType, flowId, flowName, flowType);
            }
            paramList.push(subEntry);

        }

    }
}

BpmnApiHelper.getMapParams = function (varName, definition, paramList, flowId, flowName, flowType) {
    if (!definition || !definition.entries) {
        return;
    }
    let entries = definition.entries;
    for (let e = 0; e < entries.length; e++) {
        let entry = entries[e];
        let key = entry.key;
        let entryName = varName + "." + key;
        let subMapDefinition = entry.definition;
        if (subMapDefinition && subMapDefinition.$type === "camunda:Map") {
            BpmnApiHelper.getMapParams(entryName, subMapDefinition, paramList, flowId, flowName, flowType);
        } //else {
        let value = entry.value;


        let subEntry = {
            defaultValue: value,
            id: entryName,
            label: entryName,
            type: 'string',
            flowId: flowId,
            flowName: flowName,
            flowType: flowType
        }
        paramList.push(subEntry);
        //}
    }
}

BpmnApiHelper.getInOutOutParams = function (element, paramList, flowElement) {

    if (!element) {
        return;
    }

    let outputParameters = element.outputParameters;
    if (!outputParameters) {
        return;
    }
    let flowId = flowElement.id;
    let flowName = flowElement.name ? flowElement.name : flowId;
    let flowType = flowElement.$type;
    for (let i = 0; i < outputParameters.length; i++) {
        let outputParameter = outputParameters[i];
        let result = {
            defaultValue: outputParameter.value,
            id: outputParameter.name,
            label: outputParameter.name,
            type: 'string',
            flowId: flowId,
            flowName: flowName,
            flowType: flowType

        };
        paramList.push(result);
    }
}
BpmnApiHelper.getInOutInParams = function (element, paramList, flowElement) {

    if (!element) {
        return;
    }

    let inputParameters = element.inputParameters;
    if (!inputParameters) {
        return;
    }
    let flowId = flowElement.id;
    let flowName = flowElement.name ? flowElement.name : flowId;
    let flowType = flowElement.$type;
    for (let i = 0; i < inputParameters.length; i++) {
        let inputParameter = inputParameters[i];
        let result = {
            defaultValue: inputParameter.value ? inputParameter.value : '',
            id: inputParameter.name,
            label: inputParameter.name,
            type: 'string',
            flowId: flowId,
            flowName: flowName,
            flowType: flowType,
            inputParameter: inputParameter

        };
        paramList.push(result);
    }
}

BpmnApiHelper.getFormDataOutParams = function (element, paramList, flowElement) {
    if (!element) {
        return;
    }
    let fields = element.fields;
    if (!fields) {
        return;
    }
    let flowId = flowElement.id;
    let flowName = flowElement.name ? flowElement.name : flowId;
    let flowType = flowElement.$type;

    for (let i = 0; i < fields.length; i++) {
        let field = fields[i];
        let result = {
            defaultValue: field.defaultValue,
            id: field.id,
            label: field.label,
            type: field.type,
            flowId: flowId,
            flowName: flowName,
            flowType: flowType

        };
        paramList.push(result);
    }

}
BpmnApiHelper.getPropsOutParams = function (element, paramList, flowElement) {
    if (!element) {
        return;
    }
};

BpmnApiHelper.getLoopConditionOutParams = function (element, paramList, flowElement) {
    log("BpmnApiHelper.getLoopConditionOutParams enter", flowElement);
    if (!flowElement) {
        return;
    }
    let loopCharacteristics = flowElement.loopCharacteristics;
    if (!loopCharacteristics) {
        return;
    }
    let collection = loopCharacteristics.collection ? loopCharacteristics.collection.replace("${", "").replace("}", "") : '';
    let variableName = loopCharacteristics.elementVariable;
    if (!collection || !variableName) {
        return;
    }

//    let collectionComponents = collection.split(".");
//    log("BpmnApiHelper.getLoopConditionOutParams collectionComponents", collectionComponents);
//    if (!collectionComponents || !collectionComponents.length) {
//        return;
//    }
    let flowId = flowElement.id;
    let flowName = flowElement.name ? flowElement.name : flowId;
    let flowType = flowElement.$type;

    let nameToFind = collection;//collectionComponents[0] + "." + BpmnApiHelper.firstAttPrefix;
    for (let i = 0; i < paramList.length; i++) {
        let param = paramList[i];
        let paramName = param.label;
        if (paramName.startsWith(nameToFind)) {
//            let nameComponents = paramName.split(".");
//            if (nameComponents.length < 3) {
//                continue;
//            }
            let newName = variableName + paramName.replace(nameToFind, '');
//            for (let j=2; j < nameComponents.length; j++){
//                newName = newName  +'.' + nameComponents[j];
//            }
            let result = {
                defaultValue: '',
                id: newName,
                label: newName,
                type: param.type,
                flowId: flowId,
                flowName: flowName,
                flowType: flowType


            };
            paramList.push(result);
        }
    }
};


